/**
 * Склейка классов.
 *
 * Нужна из-за noUncheckedIndexedAccess: имя класса из CSS-модуля имеет тип
 * `string | undefined`, и шаблонная строка молча вклеила бы в разметку слово
 * «undefined». Здесь оно просто отбрасывается.
 */
export function cx(...values: readonly (string | false | null | undefined)[]): string {
  return values.filter((value): value is string => typeof value === "string" && value.length > 0).join(" ")
}
